<template>

    <div class="raumplanung-ai-report">
        <div class="c-atlas-warning">
            <p>
                <strong>ACHTUNG:</strong>
                <strong> Dieser Bericht wurde automatisch von künstlicher Intelligenz (KI) erstellt und
                    nicht von Menschen geprüft. KI macht Fehler.</strong>
            </p>
            <p>
                Lesen Sie den Text kritisch und
                überprüfen Sie Aussagen mittels zusätzlicher, verlässlicher Quellen, bevor Sie auf Grundlage dieses
                Berichts
                Entscheidungen
                treffen oder
                Informationen daraus weitergeben!
            </p>

            <Collapsible header="Weitere Informationen">


                <p>
                    <span class="x-verified">Dunkelblau und fett</span> hervorgehobene Werte stammen
                    aus unserer internen Datenbank. Beim Überfahren mit der Maus werden Angaben zu Indikator und
                    Jahreszahl eingeblendet, anhand derer der Wert mit einem automatischen, verlässlichen
                    (nicht KI-basierten) Prüfverfahren mit unser Datenbank abgeglichen und verifiziert wurde.

                    Überprüfen Sie dennoch, ob diese Informationen
                    mit den Angaben zu Indikator und Jahr im Fließtext übereinstimmen.
                    Auch hier sind prinzipiell Fehler möglich, da das Prüfsystem den
                    Kontext einer Wertangabe im Text nicht erfassen kann.
                </p>

                <p>Alle sonstigen Angaben im Bericht sind grundsätzlich vollständig ungeprüft.</p>
            </Collapsible>
        </div>

        <div v-html="sanitizedAiReport" />
    </div>
</template>

<script setup lang="ts">

import { computed } from "vue";
import { RaumplanungFeatureInfoResponse } from "atlas-shared";
import { Collapsible } from "gertrud";
import { sanitizeHtml } from "../../composables/sanitizeHtml.js";



const props = defineProps<{
    featureInfo: RaumplanungFeatureInfoResponse

}>()

// The AI report is server/KI-generated HTML and must be sanitized before
// rendering via v-html to prevent XSS.
const sanitizedAiReport = computed(() => sanitizeHtml(props.featureInfo?.aiReport))



</script>
